import React from "react";
import Box from "@mui/material/Box";
import Paper from "@mui/material/Paper";

export default function WidgetWrap(props) {
  return (
    <>
      <Box
        // sx={{
        //   display: 'flex',
        //   flexWrap: 'wrap',
        //   '& > :not(style)': {
        //     m: 1,
        //     width: "0%",
        //     height: "300px",
        //   },
        // }}
        width={"50%"}
        padding={"10px 10px 0 10px"}
        // height ={"300px"}
        style={{ flex: "0 0 48%" }}
      >
        <Paper style={{ height: "320px" }}>
          <div className={props.class}>{props.children}</div>
        </Paper>
      </Box>
    </>
  );
}
